import request from '@/utils/request'

// 查询产品信息列表
export function pageProduct(query) {
  return request({
    url: '/website/product/page',
    method: 'get',
    params: query
  })
}
// 获取产品信息详细信息
export function getProductDetail(id) {
  return request({
    url: `/website/product/${id}`,
    method: 'get',
  })
}